<div class="resume-sub-section" [ngClass]="{'currently-editing' : editMode}" pFocusTrap>
  <div *ngIf="editMode">
    <ng-content select="[subSectionEdit]"></ng-content>
  </div>
  <div *ngIf="!editMode">
    <div *ngIf="hasPortfolioContent && !isOnlyPortfolioContent">
        <div header class="sub-section-header">
          <ng-container *ngTemplateOutlet="subSectionViewTemplate"></ng-container>
        </div>
        <div content>
          <bulb-resume-content-selection-display
            [units]="units"
            [renderResumeSubSectionTileView]="true">
          </bulb-resume-content-selection-display>
        </div>
    </div>
    <div *ngIf="!hasPortfolioContent" class="sub-section-view">
      <ng-container *ngTemplateOutlet="subSectionViewTemplate"></ng-container>
    </div>
    <div *ngIf="isOnlyPortfolioContent">
      <bulb-resume-content-selection-display
        [units]="units"
        [renderResumeSubSectionTileView]="true">
      </bulb-resume-content-selection-display>
    </div>
  </div>
</div>

<ng-template #subSectionViewTemplate>
  <ng-content select="[subSectionView]"></ng-content>
</ng-template>
